import { ArrowDown, AlarmClock } from "lucide-react";
import { scrollToId } from "../../lib/scroll";
import { useSection } from "../../lib/content";
import { trackCta } from "../../lib/track";
import { Reveal } from "./Reveal";

export const UpgradeBanner = () => {
  const c = useSection("upgradeBanner");

  return (
    <section data-testid="upgrade-banner" className="relative bg-white pb-10 pt-0 lg:pb-14">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="relative rounded-2xl overflow-hidden bg-[#1a1a1a] px-8 py-9 lg:px-12 lg:py-10">
            <div
              className="absolute inset-0 opacity-40"
              style={{
                backgroundImage:
                  "linear-gradient(to right, rgba(148,163,184,0.07) 1px, transparent 1px), linear-gradient(to bottom, rgba(148,163,184,0.07) 1px, transparent 1px)",
                backgroundSize: "56px 56px",
              }}
            />
            <div className="absolute -top-32 -left-32 w-[420px] h-[420px] rounded-full bg-[#024AD8]/25 blur-3xl pointer-events-none" />
            <div className="absolute -bottom-40 -right-24 w-[420px] h-[420px] rounded-full bg-[#FF5050]/10 blur-3xl pointer-events-none" />

            <div className="relative flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-12">
              <div className="flex-1 min-w-0">
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] font-semibold text-[#FF5050]">
                  {c.eyebrow}
                </p>
                <h2 className="mt-3 font-display text-2xl sm:text-3xl font-bold tracking-tight text-white leading-[1.12]">
                  {c.title}
                </h2>
                <p className="mt-3 text-sm sm:text-base text-slate-400 leading-relaxed max-w-2xl">
                  {c.lead}
                </p>
              </div>
              <button
                data-testid="upgrade-banner-cta"
                onClick={() => { trackCta("upgrade-banner"); scrollToId("contact"); }}
                className="group shrink-0 inline-flex items-center gap-3 whitespace-nowrap bg-white text-slate-900 font-semibold text-sm px-7 py-3.5 rounded-md transition-[background-color,transform] duration-300 hover:bg-[#EAF0FC] hover:scale-[1.03] active:scale-[0.98] shadow-[0_20px_50px_-12px_rgba(255,255,255,0.25)] self-start lg:self-center"
              >
                {c.ctaText}
                <ArrowDown className="w-4 h-4 transition-transform duration-300 group-hover:translate-y-1" />
              </button>
            </div>
            <div className="relative mt-6 flex flex-wrap gap-3">
              {c.deadlines.map((d) => (
                <span
                  key={d}
                  className="inline-flex items-center gap-2 whitespace-nowrap border border-[#FF5050]/40 bg-[#FF5050]/10 rounded-full px-4 py-1.5 font-mono text-[11px] font-semibold tracking-[0.08em] text-[#FF9B9B]"
                >
                  <AlarmClock className="w-3.5 h-3.5" />
                  {d}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
